import { useState, forwardRef, useImperativeHandle } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import Iconfont from '@utils/Iconfont';
import { Input } from 'antd';
import eventBus from '../../../utils/eventBus';
import API from '@api/api'
import { message } from 'antd';



const CreateTeamModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: () => setCreateTeamVisible(true),
        close: () => setCreateTeamVisible(false),
    }));


    const [createTeamVisible, setCreateTeamVisible] = useState(false);
    const [orgName, setOrgName] = useState('');
    const [loading, setLoading] = useState(false);

    const postSaveOrg = () => {
        if (!localStorage.getItem('token')) return
        setLoading(true)
        API.postSaveOrg({
            orgName,
        }).then((res) => {
            setLoading(false)
            if (res.code == 0) {
                setCreateTeamVisible(false)
                eventBus.emit('getUserOrgInfo')
                message.success('新建团队成功，即将跳转团队账号！', 1000)
                setTimeout(() => {
                    API.postChangeOrg({
                        orgId: res.data.id
                    }).then((res) => {
                        if (res.code == 0) window.location.reload()
                    })
                }, 1500)
            }
        })
    }

    const onClickOk = () => {
        if (!orgName) return
        postSaveOrg()
    }


    return <>
        <PSAIModal
            title='新建团队'
            maxWidth={400}
            okText={'确定'}
            open={createTeamVisible}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: loading }}
            onCancel={() => setCreateTeamVisible(false)}
            onOk={onClickOk}
            zIndex={1002}
        >
            <div className={styles.createTeamWrap}>
                <Input
                    size="large"
                    onChange={(e) => setOrgName(e.target.value)}
                    maxLength={20}
                    placeholder='请输入团队名称'
                    suffix={`${orgName.length}/20`}
                    prefix={<Iconfont className={styles.Icon} type="icon-reuseOutlined" />} />
                <p>• 新建的团队拥有新的独立空间，将无法同步您已有的团队数据</p>
                <p>• 如需继续使用已有团队的数据，请切换至对应团队进行付费使用</p>
            </div>
        </PSAIModal>
    </>
})
export default CreateTeamModal
